var _path, _line, _line2, _line3, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H3.5C2.94772 1 2.5 1.44772 2.5 2V38C2.5 38.5523 2.94772 39 3.5 39H30.5C31.0523 39 31.5 38.5523 31.5 38V12M20.5 1L31.5 12M20.5 1V11C20.5 11.5523 20.9477 12 21.5 12H31.5",
    stroke: "#DEDCE5",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.05884,
    y1: 17.653,
    x2: 25,
    y2: 17.653,
    stroke: "#DEDCE5",
    strokeWidth: 1.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.05884,
    y1: 24.7117,
    x2: 25,
    y2: 24.7117,
    stroke: "#DEDCE5",
    strokeWidth: 1.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.05884,
    y1: 31.7705,
    x2: 16.5294,
    y2: 31.7705,
    stroke: "#DEDCE5",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.2941,
    cy: 36.7059,
    r: 11.2941,
    fill: "#DEDCE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9413 37.8308H37.5922V42.3528H35.0191V37.8308H30.6472V35.5589H35.0191V31.0587H37.5922V35.5589H41.9413V37.8308Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.a61ec9bb.svg";
export { ForwardRef as ReactComponent };